import { MdTextFields } from "react-icons/md";
import { useDispatch } from "react-redux";
import { addNode } from "../utils/flowSlice";
import { useContext, useState } from "react";
import { DarkModeContext } from "../context/DarkModeContext";

const Text = () => {
  const dispatch = useDispatch();
  const handleButtonClick = () => {
    dispatch(addNode({ type: "textNode" }));
  };
  const { darkMode } = useContext(DarkModeContext);

  // State to track hover for each icon
  const [activeTooltip, setActiveTooltip] = useState(null);

  const handleMouseEnter = (id) => {
    setActiveTooltip(id);
  };

  const handleMouseLeave = () => {
    setActiveTooltip(null);
  };

  return (
    <div
      className="rounded-lg flex justify-center items-center relative hover:cursor-pointer"
      onMouseEnter={() => handleMouseEnter("text")}
      onMouseLeave={handleMouseLeave}
    >
      <button
        className={`w-10 h-10 mt-0.5 mx-0.5 flex items-center justify-center rounded-full transition opacity-50 ${
          darkMode ? "text-neutral-600" : "text-white"
        }`}
        onClick={handleButtonClick}
      >
        <MdTextFields size={22} />
      </button>

      {activeTooltip === "text" && (
        <span className="absolute left-full ml-2 whitespace-nowrap bg-gray-700 text-white text-xs rounded py-1 px-2 z-10">
          Text
        </span>
      )}
    </div>
  );
};

export default Text;
